import VisitorList from "../../components/admin/VisitorList.js";

function Dashboard() {
  return <VisitorList />;
}

export default Dashboard;
